export const animatePageTransition = {
    atEnter: {
        opacity: 0,
        //        offset: -100
    },
    atLeave: {
        opacity: ({ stiffness: 300, damping: 20, precision: 0.01, val: 0 }),
        //        offset: (0, { stiffness: 150, damping: 22.5, precision: 0.01, val: 100 })
    },
    atActive: {
        opacity: ({ stiffness: 20, damping: 5, precision: 0.01, val: 1 }),
        //        offset: (0, { stiffness: 150, damping: 22.5, precision: 0.01, val: 0 })
    },
    mapStyles: function mapStyles(styles) {
        return {
            opacity: styles.opacity,
            position: styles.opacity < 1 ? "absolute" : "initial",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
            //            transform: 'translateY(' + styles.offset + '%)',
            //            overflow: "none"
        };
    }
};
//e.g. url    "/office/2192/reports/stats/summary"
export const slicePathAtLevel = (location, level) => {
    let locationPathArr = location.pathname.split("/").filter(val => val);
    let pathSliced = locationPathArr.slice(0, level);
    let pathJoined = pathSliced.join("/");
    return pathJoined;
};
